import type { IconProps } from './../../models/icon';

export function HouseIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M4.28564 21.4286V10.2857L11.9999 2.57141L19.7142 10.2857V21.4286H4.28564Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M0.857178 13.7143L12 2.57141L23.1429 13.7143"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M4.28564 10.2858V21.4286H19.7142V10.2858"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M12 21.4286V16.2858"
      />
    </svg>
  );
}
